export default __webpack_public_path__ + "static/media/john_altamiranda.d2209d87.jpg";